// removed by extract-text-webpack-plugin
module.exports = {"title":"src-components-IconList----icon-list-module---title---1-l6s","iconList":"src-components-IconList----icon-list-module---iconList---1AySk src-styles----utils---deList---3vIUc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconList/icon-list.module.scss
// module id = 346
// module chunks = 168707334958949